import { STATE, GETTERS } from "./names";

export default {
    [GETTERS.WRONG_WALLET_MODAL_VISIBLE]: (state: any) => state[STATE.WRONG_WALLET_MODAL_VISIBLE],
    [GETTERS.WRONG_WALLET_MODAL_ADDRESS]: (state: any) => state[STATE.WRONG_WALLET_MODAL_ADDRESS],
}
